<template>
  <div>
    <v-container pa-0>
      <v-layout row>
        <v-flex>
          <v-card>
            <v-card-text>
              <v-layout row>
                <v-flex md3>
                  <v-select
                    :label="$t('application')"
                    :items="customerApplications"
                    item-text="application"
                    item-value="id"
                    :disabled="uploadInProgress"
                    v-model="selectedCustomerApplication"
                  >
                    <template
                      slot="item"
                      slot-scope="data"
                    >{{ data.item.application }} ({{ $tc('extension', data.item.extension.split(';').length) }} {{ beautifyFileExts(data.item.extension) }}, {{ $tc('file', data.item.filesNumber) }})</template>
                  </v-select>
                  <p class="font-italic">
                    <span
                      v-if="selectedCustomerApplication"
                    >{{ $tc('extension', selectedCustomerApplication.extension.split(';').length) }} {{ beautifyFileExts(selectedCustomerApplication.extension) }}, {{ $tc('file', selectedCustomerApplication.filesNumber) }}</span>
                    <span v-else>&nbsp;</span>
                  </p>
                </v-flex>
                <v-flex md9>
                  <v-layout column>
                    <v-flex>
                      <v-layout row align-center>
                        <v-flex shrink>
                          <input
                            type="file"
                            :multiple="multipleFilesUploadEnabled"
                            :accept="acceptedFileExtensions"
                            id="files"
                            ref="files"
                            v-show="false"
                            @change="onFilesChange"
                          >
                          <v-btn
                            :disabled="!isCustomerApplicationSelected || uploadInProgress"
                            @click.native="openFileDialog"
                          >
                            <span>{{ $t('choose_file') }}</span>
                          </v-btn>
                        </v-flex>
                        <v-flex grow>
                          <span>{{ fileNames }}</span>
                        </v-flex>
                        <v-flex shrink>
                          <v-btn :disabled="!isUploadEnabled || uploadInProgress" @click="uploadFiles">
                            <span>{{ $t('upload_file') }}</span>
                            <v-icon right dark>cloud_upload</v-icon>
                          </v-btn>
                        </v-flex>
                      </v-layout>
                      <v-layout row>
                        <v-flex grow>
                          <v-alert v-model="uploadError" type="error" dismissible outline>
                            <pre>{{ lastError ? lastError : $t('error') }}</pre>
                          </v-alert>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Constants from "../shared/constants";
import * as customerConfigActionTypes from "../store/modules/customerConfig/action-types";
// import * as customerConfigMutationTypes from "../store/modules/customerConfig/mutation-types";
import * as filesActionTypes from "../store/modules/files/action-types";
import * as filesMutationTypes from "../store/modules/files/mutation-types";
export default {
  data: () => ({
    inputFileElement: null,
    files: [],
    uploadError: false,
    lastError: null
  }),
  mounted() {
    this.inputFileElement = document.getElementById(Constants.FormData.FILES);

    this.$store.dispatch(customerConfigActionTypes.GET_CONFIGURATION_ASYNC);

    const lastUsedCustomerApplicationId = localStorage.getItem(
      Constants.LocalStorage.LAST_USED_CUSTOMER_APPLICATION_ID
    );

    if (lastUsedCustomerApplicationId) {
      this.selectedCustomerApplication = parseInt(
        lastUsedCustomerApplicationId
      );
    }

    this.$store.subscribe(mutation => {
      // (mutation, state)
      switch (mutation.type) {
        case filesMutationTypes.FILES_UPLOAD_OK:
          this.resetFiles();
          break;
        case filesMutationTypes.FILES_UPLOAD_ERROR:
          this.uploadError = true;
          this.lastError = this.handleError(mutation.payload);
          break;
      }
    });
  },
  methods: {
    openFileDialog() {
      this.inputFileElement.click();
    },
    onFilesChange() {
      this.uploadError = false;
      this.files = this.$refs[Constants.FormData.FILES].files;
    },
    uploadFiles() {
      if (this.files.length) {
        const formData = new FormData();
        for (var i = 0; i < this.files.length; i++) {
          formData.append(Constants.FormData.FILES, this.files[i]);
        }

        formData.set(
          Constants.FormData.APPLICATION,
          this.selectedCustomerApplication
            ? this.selectedCustomerApplication.application
            : ""
        );

        this.$store.dispatch(filesActionTypes.POST_FILES_ASYNC, formData);
      }
    },
    resetFiles() {
      this.inputFileElement.value = "";
      this.files = [];
    },
    beautifyFileExts(extensions, separator = "/") {
      return extensions
        .split(";")
        .map(r => `.${r.toLowerCase()}`)
        .join(separator);
    },
    handleError(response) {
      let errorString = "";

      if (response && response.title) {
        errorString = errorString.concat(
          this.$i18n.te(`errors['${response.title}']`)
            ? this.$i18n.t(`errors['${response.title}']`)
            : response.title
        );

        if (response.errors) {
          for (var suberror in response.errors) {
            if (response.errors.hasOwnProperty(suberror)) {
              errorString = errorString.concat(
                "\n",
                this.$i18n.te(`errors['${suberror}']`)
                  ? this.$i18n.t(`errors['${suberror}']`)
                  : suberror
              );
              if (response.errors[suberror]) {
                errorString = errorString.concat(":");
                for (var i in response.errors[suberror]) {
                  errorString = errorString.concat(
                    ` ${response.errors[suberror][i]}`
                  );
                }
              }
            }
          }
        }
      }

      return errorString;
    }
  },
  computed: {
    ...mapState({
      items: state => state.files.data,
      customerApplications: state => state.customerConfig.data,
      isCustomerApplicationSelected: state =>
        state.customerConfig.selectedCustomerApplicationId !== null,
      uploadInProgress: state => state.files.uploadInProgress
    }),
    selectedCustomerApplication: {
      get() {
        return this.$store.state.customerConfig.selectedCustomerApplicationId
          ? this.$store.state.customerConfig.data.find(
              obj =>
                obj.id ===
                this.$store.state.customerConfig.selectedCustomerApplicationId
            )
          : null;
      },
      set(selectedCustomerApplicationId) {
        this.resetFiles();
        this.$store.dispatch(
          customerConfigActionTypes.SET_SELECTED_APPLICATION,
          selectedCustomerApplicationId
        );
      }
    },
    multipleFilesUploadEnabled() {
      return this.selectedCustomerApplication
        ? this.selectedCustomerApplication.filesNumber !== 1
        : false;
    },
    acceptedFileExtensions() {
      return this.selectedCustomerApplication
        ? this.beautifyFileExts(this.selectedCustomerApplication.extension, ",")
        : "*";
    },
    fileNames() {
      return Array.from(this.files)
        .map(f => f.name)
        .join(", ");
    },
    isUploadEnabled() {
      return this.files.length > 0;
    }
  }
};
</script>

<style>
</style>
